module.exports = __webpack_public_path__ + "img/public/TrustIcons/Doc.svg?d5045f5f";